import { render, staticRenderFns } from "./projectintroduction.vue?vue&type=template&id=7990afc4&scoped=true&"
import script from "./projectintroduction.vue?vue&type=script&lang=js&"
export * from "./projectintroduction.vue?vue&type=script&lang=js&"
import style0 from "./projectintroduction.vue?vue&type=style&index=0&id=7990afc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990afc4",
  null
  
)

export default component.exports